import React from 'react';
import './About.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar, faCalendarAlt, faCalendarCheck, faDownload } from '@fortawesome/free-solid-svg-icons'
import { motion } from 'framer-motion';
import Skills from './Skills';

const AboutDetails = () => {
    return (
        <motion.div className='container-fluid py-5 about-details-section bg-dark'
            initial={{ width: 0 }}
            animate={{ width: "100%" }}
            exit={{ x: window.innerWidth, transition: { duration: 0.3 } }}
        >
            <div className='heading-text-size  text-white container'>
                <div className='text-center'>
                    <h2>about <span className='text-color'>me</span></h2>
                    <h5 className='text-center text-white p-3'><span className='text-warning'>&#9866;</span> I DESIGN AND CODE BEAUTIFUL THINGS, AND I LOVE WHAT I DO. <span className='text-warning'>&#9866;</span></h5>
                </div>
                <div className='row py-3'>
                    <div className='col-md-6'></div>
                    <div className='col-md-6 '>
                        <table className="table text-white">
                            <tbody>
                                <tr>
                                    <td>Name</td>
                                    <td>: Md. Nasim Reza</td>
                                </tr>
                                <tr>
                                    <td>Phone</td>
                                    <td>: +880 1779 134 383</td>
                                </tr>
                                <tr>
                                    <td>Email</td>
                                    <td>: nasimitjesbd@gmail.com</td>
                                </tr>
                                <tr>
                                    <td>Nationality</td>
                                    <td>: Bangladeshi</td>
                                </tr>
                                <tr>
                                    <td>Date of Birth </td>
                                    <td>: 30th August 1987</td>
                                </tr>
                                <tr>
                                    <td>Address</td>
                                    <td>: Dhaka, Bangladesh</td>
                                </tr>
                                <tr>
                                    <td>Experience</td>
                                    <td>: 2 years</td>
                                </tr>
                                <tr>
                                    <td>Freelancer </td>
                                    <td>: Available</td>
                                </tr>
                            </tbody>
                        </table>
                        <a href={`${process.env.PUBLIC_URL} /cv.docx`} download className='btn special-btn text-uppercase'><FontAwesomeIcon icon={faDownload} className='pe-2' /> download my cv</a>
                    </div>
                </div>
                <hr />
                <div className='row'>
                    <div className='col-md-6'>
                        <h3 className='py-3'>Experience</h3>
                        <div className='resume-items'>
                            <div className='item'>
                                <span className='bullet'></span>
                                <div className="card">
                                    <div className="card-body">
                                        <FontAwesomeIcon className='text-warning pe-2' icon={faCalendarAlt} /><small>2017-2018</small>
                                        <h5 className="card-title py-2">Web Design</h5>
                                        <p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
                                    </div>
                                </div>
                            </div>
                            <div className='item'>
                                <span className='bullet'></span>
                                <div className="card">
                                    <div className="card-body">
                                        <FontAwesomeIcon className='text-warning pe-2' icon={faCalendarAlt} /><small>2017-2018</small>
                                        <h5 className="card-title py-2">Web Development</h5>
                                        <p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
                                    </div>
                                </div>
                            </div>
                            <div className='item'>
                                <span className='bullet'></span>
                                <div className="card">
                                    <div className="card-body">
                                        <FontAwesomeIcon className='text-warning pe-2' icon={faCalendarAlt} /><small>2017-2018</small>
                                        <h5 className="card-title py-2">Full Stack Developer</h5>
                                        <p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <h3 className='py-3'>Education</h3>
                        <div className='resume-items'>
                            <div className='item'>
                                <span className='bullet'></span>
                                <div className="card">
                                    <div className="card-body">
                                        <FontAwesomeIcon className='text-warning pe-2' icon={faCalendarAlt} /><small>2017-2018</small>
                                        <h5 className="card-title py-2">Card title</h5>
                                        <p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
                                    </div>
                                </div>
                            </div>
                            <div className='item'>
                                <span className='bullet'></span>
                                <div className="card">
                                    <div className="card-body">
                                        <FontAwesomeIcon className='text-warning pe-2' icon={faCalendarAlt} /><small>2017-2018</small>
                                        <h5 className="card-title py-2">Card title</h5>
                                        <p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
                                    </div>
                                </div>
                            </div>
                            <div className='item'>
                                <span className='bullet'></span>
                                <div className="card">
                                    <div className="card-body">
                                        <FontAwesomeIcon className='text-warning pe-2' icon={faCalendarAlt} /><small>2017-2018</small>
                                        <h5 className="card-title py-2">Card title</h5>
                                        <p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <hr />
                <div className='row text-warning py-5'>
                    <h3>Skill</h3>
                </div>
                <Skills>
                    <b style={{
                        background: '#222',
                        border: '1px solid #ffb400',
                        borderWidth: '0 1px 1px 0',
                        display: 'inline-block',
                        padding: '4px',
                        transform: 'translateY(33.5px) rotate(45deg) skew(3deg, 3deg) translateX(-27px)',
                        bottom: '8px',
                        position: 'absolute',
                        boxSizing: 'border-box'
                    }}></b>
                </Skills>
            </div>
        </motion.div>
    );
};

export default AboutDetails;